import { Component, inject } from '@angular/core';
import { Mjesto } from '@app/shared/models/mjesto';
import { ListViewProviderDirective, NtapGlobalConstants } from '@ntap/core';
import { first, tap } from 'rxjs';

@Component({
  selector: 'app-odabir-povezanog-mjesta',
  templateUrl: './odabir-povezanog-mjesta.component.html',
  styleUrl: './odabir-povezanog-mjesta.component.scss'
})
export class OdabirPovezanogMjestaComponent {
  public showDialog = false;
  private listviewProvider = inject(ListViewProviderDirective);

  public onSelectedItem(mjesta: Mjesto[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentJedinicaGradivaId = (
            this.listviewProvider.viewState as {
              'en~jedinica_gradiva~id': number;
            }
          )['en~jedinica_gradiva~id'];

          mjesta.forEach((mjesto) => {
            const newItem: any = {
              'sv~mjesto~id': id,
              'sv~mjesto~mjesto_id': mjesto['en~mjesto~id'],
              'sv~mjesto~entitet_id': parentJedinicaGradivaId,
              'en~mjesto~glavni_naziv': mjesto['en~mjesto~glavni_naziv']
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(newItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }
}
